import {
  AnyAction,
  applyMiddleware,
  compose,
  createStore,
  Dispatch,
  Middleware,
} from 'redux';
import { createLogger } from 'redux-logger';
import createSagaMiddleware from 'redux-saga';

import rootReducer from '../reducers/index.reducer';
import rootSaga from '../saga/index.saga';
import { IInitialState } from '../types/initialState.types';

/**
 * redux localstorage set
 * localStorage.setItem('enableReduxLogger', JSON.stringify(true));
 */

// Mount it on the Store
const configureStore = (state: IInitialState) => {
  const sagaMiddleware = createSagaMiddleware();

  const middleware: Array<Middleware<object, any, Dispatch<AnyAction>>> = [
    sagaMiddleware,
  ];

  const enableReduxLoggerByLocalStorage = JSON.parse(
    localStorage.getItem('enableReduxLogger') || 'false'
  );

  if (
    process.env.REACT_APP_ENV === 'development' ||
    process.env.NODE_ENV === 'development' ||
    enableReduxLoggerByLocalStorage
  ) {
    const logger = createLogger({
      collapsed: true,
      duration: true,
    }) as Middleware<object, any, Dispatch<AnyAction>>;
    middleware.push(logger);
  }

  let composeEnhancer;
  if (
    process.env.REACT_APP_ENV === 'development' ||
    process.env.NODE_ENV === 'development' ||
    enableReduxLoggerByLocalStorage
  ) {
    // https://github.com/LogRocket/redux-logger#duration-boolean
    // duration: Print duration of each action. Which use full in dev and local
    composeEnhancer = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
  }

  const store = createStore(
    rootReducer,
    state as any,
    process.env.REACT_APP_ENV === 'development' ||
      enableReduxLoggerByLocalStorage
      ? composeEnhancer(applyMiddleware(...middleware))
      : applyMiddleware(...middleware)
  );
  // Run the saga
  sagaMiddleware.run(rootSaga);
  return store;
};

export default configureStore;
